export const troopsTemplates = [
  {
    act: 'anubis',
    setup: 'evenCavMages',
    desc: 'Even Cav / Mages',
    evenCavTier: 12,
    evenCav: 130000,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 220000,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'anubis',
    setup: 'evenCavArchers',
    desc: 'Even Cav / Archers',
    evenCavTier: 12,
    evenCav: 130000,
    evenInfTier: 12,
    evenInf: 0,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 220000,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'anubis',
    setup: 'oddCavArchers',
    desc: 'Odd Cav / Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 130000,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 220000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'anubis',
    setup: 'oddCavMages',
    desc: 'Odd Cav / Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 130000,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 220000
  },
  {
    act: 'sos',
    setup: 'evenCavMages',
    desc: 'Even Cav / Mages',
    evenCavTier: 12,
    evenCav: 140000,
    evenInfTier: 12,
    evenInf: 0,
    oddInfTier: 13,
    oddInf: 0,
    oddCavTier: 13,
    oddCav: 0,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 115000,
    evenArcherTier: 12,
    evenArcher: 0,
    oddArcherTier: 13,
    oddArcher: 0,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'sos',
    setup: 'evenCavArchers',
    desc: 'Even Cav / Archers',
    evenCavTier: 12,
    evenCav: 140000,
    evenInfTier: 12,
    evenInf: 0,
    oddInfTier: 13,
    oddInf: 0,
    oddCavTier: 13,
    oddCav: 0,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 115000,
    oddArcherTier: 13,
    oddArcher: 0,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'sos',
    setup: 'oddCavArchers',
    desc: 'Odd Cav / Archers',
    evenCavTier: 12,
    evenCav: 0,
    evenInfTier: 12,
    evenInf: 0,
    oddInfTier: 13,
    oddInf: 0,
    oddCavTier: 13,
    oddCav: 140000,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 0,
    oddArcherTier: 13,
    oddArcher: 115000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'sos',
    setup: 'oddCavMages',
    desc: 'Odd Cav / Mages',
    evenCavTier: 12,
    evenCav: 0,
    evenInfTier: 12,
    evenInf: 0,
    oddInfTier: 13,
    oddInf: 0,
    oddCavTier: 13,
    oddCav: 140000,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 0,
    oddArcherTier: 13,
    oddArcher: 0,
    oddMageTier: 13,
    oddMage: 115000
  },
  {
    act: 'sos',
    setup: 'evenInfMages',
    desc: 'Even Inf / Mages',
    evenCavTier: 12,
    evenCav: 100,
    evenInfTier: 12,
    evenInf: 140000,
    oddInfTier: 13,
    oddInf: 0,
    oddCavTier: 13,
    oddCav: 100,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 115000,
    evenArcherTier: 12,
    evenArcher: 0,
    oddArcherTier: 13,
    oddArcher: 0,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'sos',
    setup: 'evenInfArchers',
    desc: 'Even Inf / Archers',
    evenCavTier: 12,
    evenCav: 100,
    evenInfTier: 12,
    evenInf: 140000,
    oddInfTier: 13,
    oddInf: 0,
    oddCavTier: 13,
    oddCav: 100,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 115000,
    oddArcherTier: 13,
    oddArcher: 0,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'sos',
    setup: 'oddInfArchers',
    desc: 'Odd Inf / Archers',
    evenCavTier: 12,
    evenCav: 100,
    evenInfTier: 12,
    evenInf: 0,
    oddInfTier: 13,
    oddInf: 140000,
    oddCavTier: 13,
    oddCav: 100,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 0,
    oddArcherTier: 13,
    oddArcher: 115000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'sos',
    setup: 'oddInfMages',
    desc: 'Odd Inf / Mages',
    evenCavTier: 12,
    evenCav: 100,
    evenInfTier: 12,
    evenInf: 0,
    oddInfTier: 13,
    oddInf: 140000,
    oddCavTier: 13,
    oddCav: 100,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 0,
    oddArcherTier: 13,
    oddArcher: 0,
    oddMageTier: 13,
    oddMage: 115000
  },
  {
    act: 'ew',
    setup: 'evenCavMages',
    desc: 'Core - Even Cav / Mages',
    evenCavTier: 12,
    evenCav: 140000,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 120000,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'ew',
    setup: 'evenCavArchers',
    desc: 'Core - Even Cav / Archers',
    evenCavTier: 12,
    evenCav: 140000,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 120000,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'ew',
    setup: 'oddCavMages',
    desc: 'Core - Odd Cav / Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 140000,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 120000
  },

  {
    act: 'ew',
    setup: 'oddCavArchers',
    desc: 'Core - Odd Cav / Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 140000,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 120000,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'ew',
    setup: 'evenInfMages',
    desc: 'Core - Even Inf / Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 140000,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 120000,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'ew',
    setup: 'evenInfArchers',
    desc: 'Core - Even Inf / Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 140000,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 120000,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'ew',
    setup: 'oddInfMages',
    desc: 'Core - Odd Inf / Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 140000,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 120000
  },
  {
    act: 'ew',
    setup: 'oddInfArchers',
    desc: 'Core - Odd Inf / Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 140000,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 120000,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'ew',
    setup: 'oddCavalry',
    desc: 'Flank - Odd Cavalry',
    evenCavTier: 12,
    evenCav: 1000,
    evenInfTier: 12,
    evenInf: 0,
    oddInfTier: 13,
    oddInf: 0,
    oddCavTier: 13,
    oddCav: 140000,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 0,
    oddArcherTier: 13,
    oddArcher: 1,
    oddMageTier: 13,
    oddMage: 1
  },
  {
    act: 'ew',
    setup: 'evenCavalry',
    desc: 'Flank - Even Cavalry',
    evenCavTier: 12,
    evenCav: 140000,
    evenInfTier: 12,
    evenInf: 0,
    oddInfTier: 13,
    oddInf: 0,
    oddCavTier: 13,
    oddCav: 1000,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 0,
    oddArcherTier: 13,
    oddArcher: 1,
    oddMageTier: 13,
    oddMage: 1
  },
  {
    act: 'ew',
    setup: 'evenInfantry',
    desc: 'Flank - Even Infantry',
    evenCavTier: 12,
    evenCav: 1000,
    evenInfTier: 12,
    evenInf: 140000,
    oddInfTier: 13,
    oddInf: 1000,
    oddCavTier: 13,
    oddCav: 1000,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'ew',
    setup: 'oddInfantry',
    desc: 'Flank - Odd Infantry',
    evenCavTier: 12,
    evenCav: 1000,
    evenInfTier: 12,
    evenInf: 1000,
    oddInfTier: 13,
    oddInf: 140000,
    oddCavTier: 13,
    oddCav: 1000,
    angelTier: 12,
    angel: 90000,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'fiend',
    setup: 'evenCavMages',
    desc: 'Even Cav / Mages',
    evenCavTier: 12,
    evenCav: 12000,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 338000,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'fiend',
    setup: 'evenCavArchers',
    desc: 'Even Cav / Archers',
    evenCavTier: 12,
    evenCav: 12000,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 338000,
    oddArcherTier: 13,
    oddArcher: 0,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'fiend',
    setup: 'oddCavArchers',
    desc: 'Odd Cav / Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 12000,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 338000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'fiend',
    setup: 'oddCavMages',
    desc: 'Odd Cav / Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 349500
  },
  {
    act: 'box',
    setup: 'evenCavMages',
    desc: 'Even Cav / Mages',
    evenCavTier: 12,
    evenCav: 140000,
    evenInfTier: 12,
    evenInf: 100,
    oddInfTier: 13,
    oddInf: 100,
    oddCavTier: 13,
    oddCav: 100,
    angelTier: 12,
    angel: 100,
    evenMageTier: 12,
    evenMage: 210000,
    evenArcherTier: 12,
    evenArcher: 100,
    oddArcherTier: 13,
    oddArcher: 100,
    oddMageTier: 13,
    oddMage: 100
  },
  {
    act: 'box',
    setup: 'oddCavArchers',
    desc: 'Odd Cav / Archers',
    evenCavTier: 12,
    evenCav: 100,
    evenInfTier: 12,
    evenInf: 100,
    oddInfTier: 13,
    oddInf: 100,
    oddCavTier: 13,
    oddCav: 140000,
    angelTier: 12,
    angel: 100,
    evenMageTier: 12,
    evenMage: 100,
    evenArcherTier: 12,
    evenArcher: 100,
    oddArcherTier: 13,
    oddArcher: 210000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'box',
    setup: 'oddCavMages',
    desc: 'Odd Cav / Mages',
    evenCavTier: 12,
    evenCav: 100,
    evenInfTier: 12,
    evenInf: 100,
    oddInfTier: 13,
    oddInf: 100,
    oddCavTier: 13,
    oddCav: 140000,
    angelTier: 12,
    angel: 100,
    evenMageTier: 12,
    evenMage: 100,
    evenArcherTier: 12,
    evenArcher: 100,
    oddArcherTier: 13,
    oddArcher: 100,
    oddMageTier: 13,
    oddMage: 210000
  },
  {
    act: 'box',
    setup: 'evenInfMages',
    desc: 'Even Inf / Mages',
    evenCavTier: 12,
    evenCav: 100,
    evenInfTier: 12,
    evenInf: 140000,
    oddInfTier: 13,
    oddInf: 100,
    oddCavTier: 13,
    oddCav: 100,
    angelTier: 12,
    angel: 100,
    evenMageTier: 12,
    evenMage: 210000,
    evenArcherTier: 12,
    evenArcher: 100,
    oddArcherTier: 13,
    oddArcher: 100,
    oddMageTier: 13,
    oddMage: 100
  },
  {
    act: 'box',
    setup: 'oddInfArchers',
    desc: 'Odd Inf / Archers',
    evenCavTier: 12,
    evenCav: 100,
    evenInfTier: 12,
    evenInf: 100,
    oddInfTier: 13,
    oddInf: 140000,
    oddCavTier: 13,
    oddCav: 100,
    angelTier: 12,
    angel: 100,
    evenMageTier: 12,
    evenMage: 100,
    evenArcherTier: 12,
    evenArcher: 100,
    oddArcherTier: 13,
    oddArcher: 210000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'box',
    setup: 'oddInfMages',
    desc: 'Odd Inf / Mages',
    evenCavTier: 12,
    evenCav: 100,
    evenInfTier: 12,
    evenInf: 100,
    oddInfTier: 13,
    oddInf: 140000,
    oddCavTier: 13,
    oddCav: 100,
    angelTier: 12,
    angel: 100,
    evenMageTier: 12,
    evenMage: 100,
    evenArcherTier: 12,
    evenArcher: 100,
    oddArcherTier: 13,
    oddArcher: 100,
    oddMageTier: 13,
    oddMage: 210000
  },
  {
    act: 'sa',
    setup: 'sa-1',
    desc: 'SA - Empty',
    evenCavTier: 12,
    evenCav: 100,
    evenInfTier: 12,
    evenInf: 100,
    oddInfTier: 13,
    oddInf: 100,
    oddCavTier: 13,
    oddCav: 100,
    angelTier: 12,
    angel: 100,
    evenMageTier: 12,
    evenMage: 100,
    evenArcherTier: 12,
    evenArcher: 100,
    oddArcherTier: 13,
    oddArcher: 100,
    oddMageTier: 13,
    oddMage: 100
  },
  {
    act: 'sa',
    setup: 'sa-2',
    desc: 'SA - Mixed Front',
    evenCavTier: 12,
    evenCav: 35000,
    evenInfTier: 12,
    evenInf: 35000,
    oddInfTier: 13,
    oddInf: 35000,
    oddCavTier: 13,
    oddCav: 35000,
    angelTier: 12,
    angel: 100,
    evenMageTier: 12,
    evenMage: 100,
    evenArcherTier: 12,
    evenArcher: 100,
    oddArcherTier: 13,
    oddArcher: 100,
    oddMageTier: 13,
    oddMage: 100
  },
  {
    act: 'anubis',
    setup: 'evenInfMages',
    desc: 'Even Inf / Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 130000,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 220000,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'anubis',
    setup: 'evenInfArchers',
    desc: 'Even Inf / Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 130000,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 220000,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'anubis',
    setup: 'oddInfArchers',
    desc: 'Odd Inf / Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 130000,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 220000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'anubis',
    setup: 'oddInfMages',
    desc: 'Odd Inf / Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 130000,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 220000
  },
  {
    act: 'lodes',
    setup: 'evenMages',
    desc: 'Even Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 255000,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'lodes',
    setup: 'evenArchers',
    desc: 'Even Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 255000,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'lodes',
    setup: 'oddArchers',
    desc: 'Odd Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 255000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'lodes',
    setup: 'oddArchers2',
    desc: 'Odd Archers - II',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 0,
    evenArcherTier: 12,
    evenArcher: 0,
    oddArcherTier: 13,
    oddArcher: 255000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'lodes',
    setup: 'oddMages',
    desc: 'Odd Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 95000,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 255000
  },
  {
    act: 'undead',
    setup: 'evenCavMages',
    desc: 'Even Cav / Mages',
    evenCavTier: 12,
    evenCav: 100000,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 248000,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'undead',
    setup: 'evenCavArchers',
    desc: 'Even Cav / Archers',
    evenCavTier: 12,
    evenCav: 100000,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 248000,
    oddArcherTier: 13,
    oddArcher: 0,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'undead',
    setup: 'oddCavArchers',
    desc: 'Odd Cav / Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 100000,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 248000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'undead',
    setup: 'oddCavMages',
    desc: 'Odd Cav / Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 100000,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 248000
  },
  {
    act: 'undead',
    setup: 'evenInfMages',
    desc: 'Even Inf / Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 100000,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 248000,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 500
  },
  {
    act: 'undead',
    setup: 'evenInfArchers',
    desc: 'Even Inf / Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 100000,
    oddInfTier: 13,
    oddInf: 500,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 248000,
    oddArcherTier: 13,
    oddArcher: 0,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'undead',
    setup: 'oddInfArchers',
    desc: 'Odd Inf / Archers',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 100000,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 248000,
    oddMageTier: 13,
    oddMage: 0
  },
  {
    act: 'undead',
    setup: 'oddInfMages',
    desc: 'Odd Inf / Mages',
    evenCavTier: 12,
    evenCav: 500,
    evenInfTier: 12,
    evenInf: 500,
    oddInfTier: 13,
    oddInf: 100000,
    oddCavTier: 13,
    oddCav: 500,
    angelTier: 12,
    angel: 500,
    evenMageTier: 12,
    evenMage: 500,
    evenArcherTier: 12,
    evenArcher: 500,
    oddArcherTier: 13,
    oddArcher: 500,
    oddMageTier: 13,
    oddMage: 248000
  }
]
